import { useState, useEffect } from "react";
import "./ScrollToTopButton.scss";
import IconGoToTopArrow from "app/pages/.shared/static/icons/IconGoToTopArrow";
import { useIntersectionObserver } from "app/hooks";
import classNames from "classnames";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	const [ref, isIntersecting, entry] = useIntersectionObserver({
		threshold: 0.1,
	});

	const isLeavingFromTop = Boolean(
		!isIntersecting && (entry?.boundingClientRect?.top ?? 0) < (entry?.rootBounds?.top ?? 0)
	);

	useEffect(() => {
		setIsVisible(isLeavingFromTop);
	}, [isLeavingFromTop]);

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const buttonClass = classNames("icon scroll-to-top-btn", {
		"scroll-to-top-btn--visible": isVisible,
	});

	return (
		<>
			<div ref={ref} style={{ position: "absolute", top: "400px" }} />

			<Button
				onClick={scrollToTop}
				className={buttonClass}
				variant={BUTTON_VARIANTS.BORDERLESS}
			>
				<IconGoToTopArrow width={50} height={50} />
			</Button>
		</>
	);
};

export default ScrollToTopButton;
